/* ============================================================
   PACKAGING OUTLET â€” THEME.JS
   Shopify Cart AJAX API + Theme, Tabs, Nav, Search
   ============================================================ */

/* ---- CART AJAX API ---- */

async function addToCart(variantId, qty) {
  try {
    var addQty = parseInt(qty) || 1;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: addQty })
    });
    if (!res.ok) {
      const err = await res.json();
      showToast(err.description || 'Could not add to cart');
      return null;
    }
    const item = await res.json();
    // Update badge from current value — skip extra /cart.js round-trip
    document.querySelectorAll('#cart-count, .cart-badge').forEach(el => {
      el.textContent = (parseInt(el.textContent) || 0) + addQty;
    });
    // Extract SKU from product_title (format: [SKU]-TITLE)
    const skuMatch = item.product_title.match(/\[([^\]]+)\]/);
    const sku = skuMatch ? skuMatch[1] : 'Item';
    const qtyText = addQty > 1 ? ` x${addQty}` : '';
    showToast(`SKU: ${sku}${qtyText} added to cart`);
    return item;
  } catch {
    showToast('Could not add to cart');
    return null;
  }
}

async function changeCartItem(lineItemKey, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: parseInt(qty) })
    });
    if (!res.ok) {
      showToast('Could not update cart');
      return null;
    }
    const cart = await res.json();
    // change.js returns full cart — use item_count directly
    document.querySelectorAll('#cart-count, .cart-badge').forEach(el => {
      el.textContent = cart.item_count;
    });
    return cart;
  } catch {
    showToast('Could not update cart');
    return null;
  }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('#cart-count, .cart-badge').forEach(el => {
      el.textContent = cart.item_count;
    });
    return cart;
  } catch {
    return null;
  }
}

async function reorderItems(lineItemsJson) {
  let items;
  try { items = JSON.parse(lineItemsJson); } catch { return; }
  for (const item of items) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.variant_id, quantity: item.quantity })
    });
  }
  await updateCartCount();
  window.location.href = '/cart';
}

/* ---- TOAST ---- */
function showToast(msg) {
  let t = document.getElementById('toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'toast';
    t.style.cssText = `
      position:fixed; bottom:24px; left:50%; transform:translateX(-50%) translateY(12px);
      background:#1A2B4A; color:#fff; padding:12px 22px; border-radius:10px;
      font-size:0.875rem; font-weight:600; z-index:9999; opacity:0;
      transition:all 0.25s; pointer-events:none; white-space:nowrap;
      box-shadow:0 8px 24px rgba(0,0,0,0.3); border:1px solid rgba(255,255,255,0.1);
      display:flex; align-items:center; gap:10px;
    `;
    document.body.appendChild(t);
  }
  t.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16A34A" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> ${msg}`;
  t.style.opacity = '1';
  t.style.transform = 'translateX(-50%) translateY(0)';
  clearTimeout(t._timer);
  t._timer = setTimeout(() => {
    t.style.opacity = '0';
    t.style.transform = 'translateX(-50%) translateY(12px)';
  }, 2800);
}

/* ---- THEME ---- */
function initTheme() {
  const saved = localStorage.getItem('po_theme') || 'light';
  document.documentElement.setAttribute('data-theme', saved);
  updateThemeIcon(saved);
}

function toggleTheme() {
  const current = document.documentElement.getAttribute('data-theme') || 'light';
  const next = current === 'light' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', next);
  localStorage.setItem('po_theme', next);
  updateThemeIcon(next);
}

function updateThemeIcon(theme) {
  const icon = document.getElementById('theme-icon');
  if (!icon) return;
  if (theme === 'dark') {
    icon.innerHTML = `<circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>`;
  } else {
    icon.innerHTML = `<path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>`;
  }
}

/* ---- MOBILE NAV ---- */
function openMobileNav() {
  document.getElementById('mobile-overlay')?.classList.add('open');
  document.getElementById('mobile-drawer')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  document.getElementById('mobile-overlay')?.classList.remove('open');
  document.getElementById('mobile-drawer')?.classList.remove('open');
  document.body.style.overflow = '';
}

/* ---- TABS ---- */
function initTabs() {
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      const container = btn.closest('.tabs-wrap');
      if (!container) return;
      container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      container.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const panel = container.querySelector(`#tab-${target}`);
      if (panel) panel.classList.add('active');
    });
  });
}

/* ---- SEARCH ---- */
function handleHeaderSearch(e) {
  if (e.key === 'Enter') {
    const q = e.target.value.trim();
    if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
  }
}

function handleHeroSearch() {
  const input = document.getElementById('hero-search-input');
  if (!input) return;
  const q = input.value.trim();
  if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
}

function filterByTag(tag, isChecked) {
  const params = new URLSearchParams(window.location.search);
  let tags = params.getAll('filter.p.tag') || [];

  if (isChecked) {
    if (!tags.includes(tag)) {
      tags.push(tag);
    }
  } else {
    tags = tags.filter(t => t !== tag);
  }

  const baseUrl = window.location.pathname;
  const newParams = new URLSearchParams();
  tags.forEach(t => newParams.append('filter.p.tag', t));
  const newUrl = tags.length > 0 ? baseUrl + '?' + newParams.toString() : baseUrl;
  window.location.href = newUrl;
}

function initHeroSearch() {
  const input = document.getElementById('hero-search-input');
  if (!input) return;
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') handleHeroSearch();
  });
}

/* ---- QTY STEPPER ON PRODUCT PAGE ---- */
function initQtyStepper() {
  const dec = document.getElementById('qty-dec');
  const inc = document.getElementById('qty-inc');
  const inp = document.getElementById('qty-value');
  if (!dec || !inc || !inp) return;
  dec.addEventListener('click', () => { const v = Math.max(1, parseInt(inp.value) - 1); inp.value = v; });
  inc.addEventListener('click', () => { inp.value = parseInt(inp.value) + 1; });
}

function stepQty(inputId, delta) {
  const inp = document.getElementById(inputId);
  if (!inp) return;
  const v = Math.max(1, parseInt(inp.value) + delta);
  inp.value = v;
}


/* ---- ACCESSORIES VIEW TOGGLE ---- */
function setAccessoriesView(view) {
  const tableView = document.getElementById('accessories-table-view');
  const gridView = document.getElementById('accessories-grid-view');
  const tableBtn = document.getElementById('view-acc-table-btn');
  const gridBtn = document.getElementById('view-acc-grid-btn');
  if (!tableView || !gridView) return;
  if (view === 'grid') {
    tableView.classList.add('hidden');
    gridView.classList.add('visible');
    if (tableBtn) tableBtn.classList.remove('active');
    if (gridBtn) gridBtn.classList.add('active');
  } else {
    tableView.classList.remove('hidden');
    gridView.classList.remove('visible');
    if (tableBtn) tableBtn.classList.add('active');
    if (gridBtn) gridBtn.classList.remove('active');
  }
  localStorage.setItem('po_accessories_view', view);
}

/* ---- PARTS VIEW TOGGLE ---- */
function setPartsView(view) {
  const tableView = document.getElementById('parts-table-view');
  const gridView = document.getElementById('parts-grid-view');
  const tableBtn = document.getElementById('view-table-btn');
  const gridBtn = document.getElementById('view-grid-btn');
  if (!tableView || !gridView) return;
  if (view === 'grid') {
    tableView.classList.add('hidden');
    gridView.classList.add('visible');
    if (tableBtn) tableBtn.classList.remove('active');
    if (gridBtn) gridBtn.classList.add('active');
  } else {
    tableView.classList.remove('hidden');
    gridView.classList.remove('visible');
    if (tableBtn) tableBtn.classList.add('active');
    if (gridBtn) gridBtn.classList.remove('active');
  }
  localStorage.setItem('po_parts_view', view);
}

/* ---- ACTIVE NAV ---- */
function setActiveNav() {
  const path = window.location.pathname;
  document.querySelectorAll('.header-nav a, .sidebar-nav a, .mobile-drawer a').forEach(a => {
    const href = a.getAttribute('href') || '';
    const isActive =
      (href === '/' && path === '/') ||
      (href !== '/' && href.length > 1 && path.startsWith(href));
    if (isActive) {
      a.classList.add('active');
    } else {
      a.classList.remove('active');
    }
  });
}

/* ---- MACHINE PILL FILTER (collection page, URL-based) ---- */
function filterByPill(tagValue) {
  const base = window.location.pathname;
  if (!tagValue) {
    window.location.href = base;
  } else {
    window.location.href = `${base}?filter.p.tag=${encodeURIComponent(tagValue)}`;
  }
}

function initPillActiveState() {
  const params = new URLSearchParams(window.location.search);
  const activeTag = params.get('filter.p.tag') || '';
  document.querySelectorAll('.machine-pill').forEach(pill => {
    const val = pill.dataset.tag || '';
    if (val === '' && activeTag === '') {
      pill.classList.add('active');
    } else if (val && activeTag === val) {
      pill.classList.add('active');
    } else {
      pill.classList.remove('active');
    }
  });
}

/* ---- SCROLL ANIMATIONS ---- */
function initScrollAnimations() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(el => el.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
}

/* ---- ONBOARDING DISMISS ---- */
function dismissOnboarding(id) {
  const el = document.getElementById(id);
  if (el) {
    el.style.transition = 'opacity 0.2s';
    el.style.opacity = '0';
    setTimeout(() => { el.style.display = 'none'; }, 220);
  }
  localStorage.setItem('po_dismissed_' + id, '1');
}

/* ---- COMPAT EXPAND (product page) ---- */
function toggleCompatModels(btn) {
  const panel = document.getElementById('compat-models');
  if (!panel) return;
  const expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  panel.hidden = expanded;
  const chevron = btn.querySelector('.compat-chevron');
  if (chevron) chevron.classList.toggle('rotated', !expanded);
  btn.childNodes[0].textContent = expanded ? 'View exact models ' : 'Hide exact models ';
}

/* ---- CART PAGE: QTY + REMOVE (calls Shopify then reloads) ---- */
async function cartUpdateQty(lineKey, newQty) {
  await changeCartItem(lineKey, newQty);
  window.location.reload();
}

async function cartRemoveItem(lineKey) {
  await changeCartItem(lineKey, 0);
  window.location.reload();
}

/* ---- FILTER PANEL TOGGLE (MOBILE) ---- */
function toggleFilterPanel() {
  const filterPanel = document.getElementById('filter-panel');
  const filterBtn = document.getElementById('filter-toggle-btn');
  if (!filterPanel) return;
  filterPanel.classList.toggle('expanded');
  if (filterBtn) {
    filterBtn.classList.toggle('active');
    filterBtn.textContent = filterPanel.classList.contains('expanded') ? 'Hide Filters' : 'Filters';
  }
}

/* ---- COLLECTION SEARCH ---- */
function handleCollectionSearch(e) {
  if (e.key === 'Enter') {
    performCollectionSearch();
  }
}

function performCollectionSearch() {
  const q = document.getElementById('collection-search-input')?.value.trim();
  if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
}

/* ---- INIT ---- */
document.addEventListener('DOMContentLoaded', () => {
  initTheme();
  updateCartCount();
  setActiveNav();
  initTabs();
  initQtyStepper();
  initHeroSearch();
  initPillActiveState();
  initScrollAnimations();

  if (document.getElementById('parts-table-view')) {
    setPartsView(localStorage.getItem('po_parts_view') || 'table');
  }

  if (document.getElementById('accessories-table-view')) {
    setAccessoriesView(localStorage.getItem('po_accessories_view') || 'table');
  }

  // Restore dismissed onboarding banners
  document.querySelectorAll('[id^="onboarding-"]').forEach(el => {
    if (localStorage.getItem('po_dismissed_' + el.id)) {
      el.style.display = 'none';
    }
  });
});
